<template>
  <div>
    <el-select
      v-model="label"
      class="mr-3"
      placeholder="選擇層級"
      @change="onSelect"
    >
      <el-option
        v-for="item in roleLabels"
        :key="item.name"
        :label="item.name"
        :value="item.value"
      />
    </el-select>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  data() {
    return {
      label: ''
    }
  },
  computed: {
    ...mapGetters('variable', ['roleLabel', 'roleLabels'])
  },
  created() {
    this.label = this.roleLabel
    this.$emit('onSelect', this.label)
  },
  methods: {
    ...mapMutations('variable', ['setRoleLabel']),
    onSelect() {
      this.setRoleLabel(this.label)
      this.$emit('onSelect', this.label)
    }
  }
}
</script>
